import api from 'api';

export const BATCH_RECIPES_ASYNC_ACTION_START = 'BATCH_RECIPES_ASYNC_ACTION_START';
export const BATCH_RECIPES_ASYNC_ACTION_ERROR = 'BATCH_RECIPES_ASYNC_ACTION_ERROR';
export const BATCH_RECIPES_ASYNC_UPDATE_ACTION_SUCCESS = 'BATCH_RECIPES_ASYNC_UPDATE_ACTION_SUCCESS';
export const BATCH_RECIPES_RESET_STATE = 'BATCH_RECIPES_RESET_STATE';

function batchRecipesAsyncActionStart() {
  return {
    type: BATCH_RECIPES_ASYNC_ACTION_START,
  };
}

function batchRecipesAsyncActionError(error) {
  return {
    type: BATCH_RECIPES_ASYNC_ACTION_ERROR,
    error,
  };
}

function batchRecipesAsyncUpdateSuccess(data) {
  return {
    type: BATCH_RECIPES_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

export function resetBatchRecipesState() {
  return {
    type: BATCH_RECIPES_RESET_STATE,
  };
}

//for Ingredients Batch Recipes
export function getBatchRecipesAsync(brandId) {
  return (dispatch, getState) => {
    dispatch(batchRecipesAsyncActionStart());
    return api.request(`recipe/list?brandId=${ brandId }&fetchBatch=true`, 'get')
    .then((data) => {
      dispatch(batchRecipesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipesAsyncActionError('Unable to get Recipes'));
      throw (err);
    });
  };
}

//for Ingredients Batch Recipes Auto Suggest dropdown option
export function getBatchRecipesAsyncWithBatchLevel(brandId, batchLevel) {
  return (dispatch, getState) => {
    dispatch(batchRecipesAsyncActionStart());
    let apilink;
    if(typeof batchLevel =='undefined') {
      apilink = `recipe/list?brandId=${ brandId }&fetchBatch=true`;
    } else {
      apilink = `recipe/list?brandId=${ brandId }&fetchBatch=true&batchLevel=${batchLevel}`;
    }

    return api.request(apilink, 'get')
    .then((data) => {
      dispatch(batchRecipesAsyncUpdateSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(batchRecipesAsyncActionError('Unable to get Recipes'));
      throw (err);
    });
  };
}
